angular.module('ihestiaWidgets.eua', []);